import { b64ToBlob } from './helper/b64ToBlob';
import * as classNames from 'classnames';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../dialog/dialog_wrapper_v2';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import '../../css/react-viewer.css';
import style from './WArchivIcon.less';
import Viewer from 'react-viewer';
import { WExcelViewer } from '../excel/WExcelViewer';

interface WArchivIconProps extends React.ClassAttributes<any> {
    archivId: number;
    filePathDirect?: string;
    inlineMode?: boolean;
    title?: JSX.Element;
    hideIcon?: boolean;
    hideFilename?: boolean;
    fixedHight?: boolean;
    previewSize?: number;
    previewMaxWidth?: number;
    previewMaxHeight?: number;
    iconSize?: number;
    previewFontSize?: number;
    module?: string;
    name?: string;
    useStandardIcon?: boolean;
    URLContextKey?: string;
    onGetFileContent?: (blob: any, url: string, base64: string) => void;
    onValueChange?(name: string, value: any): void;
}

interface WArchivIconState {
    fileInfo: any;
    fileBlob: any;
    fileB64: string;
    fileUrl: string;
    fileError: string;
    showDialog: boolean;
    showImageViewer: boolean;
    previewSize: number;
    pdfObjSize: any;
    loadContent: boolean;
}

export class WArchivIcon extends React.Component<WArchivIconProps, WArchivIconState> {
    constructor(props: any) {
        super(props);
        this.state = {
            fileInfo: undefined,
            fileBlob: undefined,
            fileB64: undefined,
            fileUrl: undefined,
            fileError: undefined,
            showDialog: false,
            showImageViewer: false,
            previewSize: this.props.previewSize ? this.props.previewSize : 60,
            pdfObjSize: undefined,
            loadContent: this.props.inlineMode ? true : false
        };
        this.getFileInfo = this.getFileInfo.bind(this);
        this.ImageViewerContainer = React.createRef();
        this.WaitingDownload = false;
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(ContextService) private contextService: ContextService;

    private ImageViewerContainer: any;
    private GetFileInfoParams: any;
    private WaitingDownload: Boolean;

    UNSAFE_componentWillMount() {
        if (this.props.filePathDirect) {
            this.getFileInfo(this.props.filePathDirect, 'direct');
        } else {
            this.loadArchiv(this.props.archivId, this.getFileInfo);
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props.inlineMode) {
            if (!prevState.fileBlob && this.state.fileBlob) {
                this.setState({ showImageViewer: true });
            }
        }

        if (prevState.loadContent === false && this.state.loadContent === true && this.state.fileInfo && this.GetFileInfoParams) {
            const params = this.GetFileInfoParams;
            this.getFileContent(params.path, params.mode, this.state.fileInfo);
        }
    }

    UNSAFE_componentWillReceiveProps(propsNew: any) {
        if (!propsNew.filePathDirect && propsNew.archivId !== this.props.archivId) {
            this.loadArchiv(propsNew.archivId, this.getFileInfo);
        }

        if (propsNew.filePathDirect && propsNew.filePathDirect !== this.props.filePathDirect) {
            this.getFileInfo(propsNew.filePathDirect, 'direct');
        }
    }

    getClassByType(type: string) {
        let cls = '';
        if (type === 'XLS') {
            cls = style.excel;
        } else if (type === 'DOC') {
            cls = style.word;
        } else if (type === 'PDF') {
            cls = style.pdf;
        } else if (type === 'ZIP') {
            cls = style.zip;
        } else if (type === 'TXT') {
            cls = style.txt;
        } else {
            cls = style.file;
        }
        return cls;
    }

    getFileContent(path: string, mode: string, fileInfo: any) {
        this.dataService.loadRessource(path, mode, (b64: string) => {
            b64ToBlob(b64, fileInfo.mime, (blob: any) => {
                const url = window.URL.createObjectURL(blob);
                // console.log(url);
                this.setState({ fileBlob: blob, fileB64: b64, fileUrl: url });
                if (this.props.URLContextKey) {
                    this.contextService.set(this.props.URLContextKey, url);
                }
                if (typeof this.props.onGetFileContent === 'function') {
                    this.props.onGetFileContent(blob, url, b64);
                }
            });
        }, this.props.module);
    }

    getFileInfo(path: string, mode: string) {
        this.GetFileInfoParams = { path, mode };
        this.dataService.getRessourceInfo(path, mode, (info: any) => {
            // console.log(path, mode, info);
            if (info) {
                if (info.thumbnail) {
                    b64ToBlob(info.thumbnail, info.mime, (blob: any) => {
                        info.thumbnail = window.URL.createObjectURL(blob);
                        this.setState({ fileInfo: info });
                    });
                } else {
                    this.setState({ fileInfo: info });
                }
                if (this.state.loadContent || this.props.URLContextKey) {
                    this.getFileContent(path, mode, info);
                }
                this.setState({ fileError: undefined });
            } else {
                this.setState({ fileError: i18n('Datei nicht verfügbar.', 'sys') });
            }
        }, this.props.module);
    }

    getFileType(filename: string) {
        const flow = filename.toLocaleLowerCase();

        if (flow.endsWith('.png') || flow.endsWith('.jpg') || flow.endsWith('.jpeg') || flow.endsWith('.gif')) {
            return 'IMG';
        }
        if (flow.endsWith('.xls') || flow.endsWith('.xlsx') || flow.endsWith('.csv')) {
            return 'XLS';
        }
        if (flow.endsWith('.doc') || flow.endsWith('.docx') || flow.endsWith('.rtf')) {
            return 'DOC';
        }
        if (flow.endsWith('.pdf')) {
            return 'PDF';
        }
        if (flow.endsWith('.zip')) {
            return 'ZIP';
        }
        if (flow.endsWith('.txt')) {
            return 'TXT';
        }
        return 'FILE';
    }

    getIconStyle() {
        if (this.props.iconSize > 0) {
            return {
                minWidth: this.props.iconSize,
                minHeight: this.props.iconSize,
                backgroundSize: this.props.iconSize
            };
        }
        return {};
    }

    getShortName(fileName: string) {
        return fileName.substr(fileName.indexOf('_') + 1);
    }

    loadArchiv(archivId: number, callback: (path: string, mode: string) => void) {
        this.dataService.loadDataForModul(
            IDs.ENT_ARCHIV_ITEMS,
            { tid: archivId },
            { resolve: true, fieldList: 'name, file' },
            this.props.module || 'wips',
            (result: any) => {
                // console.log(archivId, result);
                if (result[IDs.ENT_ARCHIV_ITEMS] && result[IDs.ENT_ARCHIV_ITEMS][0]) {
                    let fileName = result[IDs.ENT_ARCHIV_ITEMS][0]['file'];

                    if (fileName.substr(0, 11) === 'wips3_2013/') {
                        fileName = fileName.substr(11);
                    }
                    callback(fileName, 'archiv');
                    this.setState({ fileError: undefined });
                } else {
                    this.setState({ fileError: i18n('Datei nicht verfügbar.', 'sys') });
                }
            }
        );
    }

    render() {
        if (this.state.fileError) {
            return (
                <span style={{ color: 'red', fontStyle: 'italic' }}>
                    {this.state.fileError}
                </span>
            );
        } else if (this.state.fileInfo) {
            const type = this.getFileType(this.state.fileInfo.name);

            if (this.props.useStandardIcon) {
                return this.renderDownload(type);
            } else
                if (type === 'IMG') {
                    return this.renderImage();
                } else if (type === 'PDF') {
                    return this.renderPDF();
                } else if (false && type === 'XLS') {
                    return this.renderXLS();
                } else if (type === 'TXT') {
                    return this.renderTxt();
                } else {
                    return this.renderDownload(type);
                }
        }
        return <i>{i18n('Lade', 'sys')}...</i>;
    }

    renderDownload(type: string) {
        const fileName = this.state.fileInfo.name;
        const shortName = this.getShortName(fileName);
        const iconClass = this.props.useStandardIcon ? style.file : this.getClassByType(type);
        if (this.state.fileUrl && this.WaitingDownload) {
            this.WaitingDownload = false;
            // const a = document.createElement('a');
            // a.title = shortName;
            // a.href = this.state.fileUrl;
            // a.download = shortName;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(this.state.fileUrl, shortName);
        }

        return (
            <div
                title={`${shortName} (${i18n('Herunterladen', 'sys')})`}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                    this.setState({ loadContent: true });
                    this.WaitingDownload = true;
                }}
            >
                <div className={classNames(style.file, iconClass)} style={this.getIconStyle()}>
                    {this.state.loadContent && !this.state.fileUrl
                        ? <span className={style.lade}>{i18n('Lade', 'sys')}...</span> : null
                        // : <span className={style.download}>{String.fromCharCode(8675)}</span>
                    }
                </div>
                {this.props.hideFilename !== true &&
                    <div
                        className={style.label}
                        style={{ fontSize: this.props.previewFontSize ? this.props.previewFontSize + 'px' : undefined }}
                    >
                        {shortName}
                    </div>}
            </div>
        );
    }

    renderImage() {
        const { fixedHight } = this.props;
        const thumbUrl = this.state.fileInfo.thumbnail;
        const fileName = this.getShortName(this.state.fileInfo.name);
        const imgUrl = this.state.fileUrl;
        const vp = {
            visible: this.state.showImageViewer,
            images: [{ src: imgUrl, alt: fileName }],
            noNavbar: true,
            changeable: false,
            onClose: () => { this.setState({ showImageViewer: false }); }
        };
        let previewMaxWidth = !fixedHight ? this.state.previewSize : 'unset';
        let previewMaxHeight = !fixedHight ? this.state.previewSize : 'unset';
        if (this.props.previewMaxHeight) {
            previewMaxHeight = this.props.previewMaxHeight;
        }
        if (this.props.previewMaxWidth) {
            previewMaxWidth = this.props.previewMaxWidth;
        }
        return (
            <div>
                {this.props.inlineMode === true &&
                    <div>
                        <div
                            ref={this.ImageViewerContainer}
                            style={{ width: 600, height: 600 }}
                        />
                        {imgUrl &&
                            <Viewer
                                visible={vp.visible}
                                images={vp.images}
                                noNavbar={vp.noNavbar}
                                changeable={vp.changeable}
                                noClose={true}
                                container={this.ImageViewerContainer.current}
                            />
                        }
                    </div>
                }
                {!this.props.inlineMode &&
                    <div
                        title={fileName}
                        style={{ position: 'relative' }}
                    >
                        <img
                            src={thumbUrl}
                            style={{
                                cursor: 'pointer',
                                minWidth: 20,
                                minHeight: 20,
                                maxWidth: previewMaxWidth,
                                maxHeight: previewMaxHeight,
                                height: fixedHight ? this.state.previewSize : 'unset',
                                marginTop: 0
                            }}
                            alt={i18n('Bild', 'sys')}
                            onClick={() => this.setState({ loadContent: true, showImageViewer: true })}
                        />
                        {this.props.hideFilename !== true &&
                            <div
                                className={style.label}
                                style={{ fontSize: this.props.previewFontSize ? this.props.previewFontSize + 'px' : undefined }}
                            >
                                {fileName}
                            </div>
                        }
                        {this.state.loadContent && !imgUrl &&
                            <span
                                className={style.lade}
                                style={{ position: 'absolute', top: 0, left: 0 }}
                            >
                                {i18n('Lade', 'sys')}....
                            </span>
                        }
                        {imgUrl &&
                            <Viewer
                                visible={vp.visible}
                                images={vp.images}
                                noNavbar={vp.noNavbar}
                                changeable={vp.changeable}
                                zIndex={100000}
                                onClose={vp.onClose}
                                onMaskClick={vp.onClose}
                            />
                        }
                    </div>
                }
            </div>
        );
    }

    renderPDF() {
        const fileName = this.state.fileInfo.name;
        const shortName = this.getShortName(fileName);
        const iconClass = this.props.useStandardIcon ? style.file : style.pdf;
        const content = this.state.fileUrl
            ? <object
                style={{
                    minWidth: this.state.pdfObjSize && this.state.pdfObjSize.width ? this.state.pdfObjSize.width : 806,
                    ...(this.state.pdfObjSize && this.state.pdfObjSize.height ? { minHeight: this.state.pdfObjSize.height } : {}),
                    ...(!this.state.pdfObjSize || !this.state.pdfObjSize.height ? { maxHeight: '75vh' } : {}),
                    width: '100%',
                    height: this.state.pdfObjSize && this.state.pdfObjSize.height ? '100%' : 806,
                    borderBottomRightRadius: 'var(--border-radius-dialog)', borderBottomLeftRadius: 'var(--border-radius-dialog)',
                    marginBottom: -5
                }}
                // type='application/pdf' // der type ist nicht kompatibel mit Safari
                data={this.state.fileUrl}
                aria-label=''
            />
            : null;
        return (
            <div>
                {this.props.inlineMode === true && content}
                {!this.props.inlineMode &&
                    <div>
                        <div
                            title={shortName}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ loadContent: true, showDialog: true })}
                        >
                            {this.props.hideIcon !== true &&
                                <div className={classNames(style.file, iconClass)} style={this.getIconStyle()}>
                                    {this.state.loadContent && !this.state.fileUrl && <span className={style.lade}>{i18n('Lade', 'sys')}...</span>}
                                </div>
                            }
                            {this.props.hideFilename !== true &&
                                <div
                                    className={style.label}
                                    style={{ fontSize: this.props.previewFontSize ? this.props.previewFontSize + 'px' : undefined }}
                                >
                                    {shortName}
                                </div>
                            }
                            {this.props.title &&
                                <div className={style.label}>{this.props.title}</div>
                            }
                        </div>
                        {this.state.showDialog && content &&
                            <div>
                                <DialogWrapper2
                                    title={i18n('Vorschau', 'sys')}
                                    width={-1}
                                    onAfterClose={() => this.setState({ showDialog: false })}
                                    onResize={(size: any) => {
                                        size.height -= 90;
                                        this.setState({ pdfObjSize: size });
                                    }}
                                >
                                    <div>{content}</div>
                                </DialogWrapper2>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }

    renderTxt() {
        const fileName = this.state.fileInfo.name;
        const shortName = this.getShortName(fileName);
        const iconClass = this.props.useStandardIcon ? style.file : style.txt;
        let stringTxt;

        if (this.state.fileB64) {
            try {
                stringTxt = atob(this.state.fileB64);
            } catch (e) {
                // console.error(e);
            }
        }
        const content = this.state.fileB64
            ? <textarea
                style={{ minWidth: 300, minHeight: 300, width: 600, height: 600, fontSize: 12, fontFamily: 'Consolas' }}
                readOnly={true}
                value={stringTxt}
            />
            : null;

        return (
            <div>
                {this.props.inlineMode === true && content}
                {!this.props.inlineMode &&
                    <div>
                        <div
                            title={shortName}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ loadContent: true, showDialog: true })}
                        >
                            <div className={classNames(style.file, iconClass)} style={this.getIconStyle()}>
                                {this.state.loadContent && !this.state.fileB64 && <span className={style.lade}>{i18n('Lade', 'sys')}...</span>}
                            </div>
                            {this.props.hideFilename !== true &&
                                <div className={style.label}>{shortName}</div>
                            }
                        </div>
                        {this.state.showDialog && content &&
                            <div>
                                <DialogWrapper2
                                    title={i18n('Vorschau', 'sys')}
                                    width={-1}
                                    onAfterClose={() => this.setState({ showDialog: false })}
                                >
                                    <div>{content}</div>
                                </DialogWrapper2>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }

    renderXLS() {
        const fileName = this.state.fileInfo.name;
        const shortName = this.getShortName(fileName);
        const iconClass = this.props.useStandardIcon ? style.file : style.excel;
        const content = this.state.fileB64
            ? <div>
                {this.renderDownload('XLS')}
                <WExcelViewer
                    data={this.state.fileB64}
                />
            </div>
            : null;

        return (
            <div>
                {this.props.inlineMode === true && content}
                {!this.props.inlineMode &&
                    <div>
                        <div
                            title={shortName}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ loadContent: true, showDialog: true })}
                        >
                            <div className={classNames(style.file, iconClass)} style={this.getIconStyle()}>
                                {this.state.loadContent && !this.state.fileB64 && <span className={style.lade}>{i18n('Lade', 'sys')}...</span>}
                            </div>
                            {this.props.hideFilename !== true &&
                                <div
                                    className={style.label}
                                    style={{ fontSize: this.props.previewFontSize ? this.props.previewFontSize + 'px' : undefined }}
                                >
                                    {shortName}
                                </div>
                            }
                        </div>
                        {this.state.showDialog && content &&
                            <div>
                                <DialogWrapper2
                                    title={i18n('Vorschau', 'sys')}
                                    width={-1}
                                    onAfterClose={() => this.setState({ showDialog: false })}
                                >
                                    <div style={{ minWidth: 800 }}>
                                        {content}
                                    </div>
                                </DialogWrapper2>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}
